module.exports = __webpack_public_path__ + "img/frosty.9d222a34.svg";